import { useState, useEffect } from "react";
import { Grid, TextField, Button, Typography, Card, CardContent, Box } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import KeyIcon from '@mui/icons-material/Key';
import axios from "axios";
import Helpers from "../Helpers";

const docWidth = window.innerWidth;

const styles = {
    card: {
        width: (docWidth > 420) ? 430 : '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: '1%',
        backgroundColor: '#fff',
        border: '1px solid #CCC',
        borderRadius: 3,
    },
    box1: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    btnCard: {
        backgroundColor: '#CCC',
        border: '1px solid #CCC',
        color: '#242424',
    },
    boxButtons: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        gap: 5,
    },
};

function Usuarios(){
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [listaUsuarios, setListaUsuarios] = useState([]);

    const getUsersList = async() => {
        let alertForm = {};

        try {
            const rota = `${urlApi}/lista_usuarios`;
            const resp = await axios.get(rota);
            const data = resp.data;
            
            setListaUsuarios(data);
        } catch (error) {
            alertForm = {
                title: `Falhou !!! ${error.message}`,
                icon: 'error',
            };
            return Helpers.toastAlert(alertForm);
        }
    };

    useEffect(()=>{
        getUsersList();
    }, []);

    const handleLiberarSenha = async(id_user) => {
        let alertForm = {};

        Helpers.showAlert({
            title: `Aguarde !!!`,
            text: 'Gerando senha',
            icon: 'info',
        }, null);

        try {
            const rota = `${urlApi}/gera_senha`;
            const resp = await axios.post(rota, {id: id_user});
            const data = resp.data;
            
            setListaUsuarios(data.lista);
            return Helpers.toastAlert(data.validation);
        } catch (error) {
            alertForm = {
                title: `Falhou !!! ${error.message}`,
                icon: 'error',
            };
            return Helpers.toastAlert(alertForm);
        }
    };

    const handleAlteraAcesso = async(id_user) => {
        let alertForm = {};

        Helpers.showAlert({
            title: `Aguarde !!!`,
            text: 'Liberando acesso',
            icon: 'info',
        }, null);

        try {
            const rota = `${urlApi}/atualizar_acesso`;
            const resp = await axios.post(rota, {id: id_user});
            const data = resp.data;
            
            setListaUsuarios(data.lista);
            return Helpers.toastAlert(data.validation);
        } catch (error) {
            alertForm = {
                title: `Falhou! ${error.message}`,
                icon: 'error',
            };
            return Helpers.toastAlert(alertForm);
        }
    };

    return (
        <Grid container rowSpacing={2}>
            <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Usuários</Typography>

            <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
            {
                listaUsuarios &&
                listaUsuarios.map((item, index) => {
                    return (
                        <Box key={index} style={styles.card}>
                            <Box style={styles.box1}>
                                <Typography component="div"> {`Id: ${item.id}`} </Typography>
                                <Typography component="div"> {`Cd usuário: ${item.cd_usuario}`} </Typography>
                                <Typography component="div"> {`Cd funcionário: ${item.cd_funcionario}`} </Typography>
                            </Box>

                            <Typography component="div"> {`Nome: ${item.name}`} </Typography>
                            <Typography component="div"> {`Email: ${item.email}`} </Typography>

                            <Box style={styles.box1}>
                                <Typography component="div"> {`Tipo: ${item.tipo}`} </Typography>
                                <Typography component="div"> {`Acesso: ${item.acesso}`} </Typography>
                            </Box>

                            <Box style={styles.boxButtons}>
                                <Button onClick={()=>handleLiberarSenha(item.id)} startIcon={<LockOpenIcon />} style={styles.btnCard}>Senha</Button>
                                <Button onClick={()=>handleAlteraAcesso(item.id)} startIcon={<KeyIcon />} style={styles.btnCard}>Acesso</Button>
                            </Box>
                        </Box>
                    );
                })
            }
            </Grid>
        </Grid>
    );
}

export default Usuarios;